import * as React from "react"
const Puzzle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.358}
      d="M26.068 10.303c-.064.423.077.85.378 1.153l2.05 2.058a3.16 3.16 0 0 1 .924 2.236c0 .81-.308 1.618-.924 2.237L26.39 20.1a1.28 1.28 0 0 1-1.094.362c-.615-.092-1.049-.63-1.266-1.214a3.283 3.283 0 0 0-2.368-2.066 3.257 3.257 0 0 0-3.01.885 3.284 3.284 0 0 0-.883 3.023 3.287 3.287 0 0 0 2.059 2.377c.583.217 1.118.652 1.21 1.27a1.29 1.29 0 0 1-.362 1.099l-2.105 2.113a3.142 3.142 0 0 1-4.457.001l-2.05-2.058a1.34 1.34 0 0 0-1.147-.38c-.645.097-1.098.66-1.334 1.27a3.28 3.28 0 0 1-2.374 2.02 3.256 3.256 0 0 1-2.983-.891 3.283 3.283 0 0 1-.887-2.994 3.286 3.286 0 0 1 2.012-2.384c.607-.236 1.169-.691 1.264-1.338a1.351 1.351 0 0 0-.378-1.151l-2.05-2.058a3.154 3.154 0 0 1-.923-2.237c0-.81.309-1.62.923-2.236l1.996-2.003c.313-.315.76-.464 1.199-.398.673.101 1.146.693 1.402 1.326a3.28 3.28 0 0 0 2.38 1.977 3.257 3.257 0 0 0 2.959-.896 3.284 3.284 0 0 0 .892-2.97 3.287 3.287 0 0 0-1.97-2.389c-.63-.257-1.22-.732-1.32-1.408a1.412 1.412 0 0 1 .396-1.204l1.994-2.001a3.14 3.14 0 0 1 4.455.001l2.05 2.058c.3.302.727.444 1.147.38.644-.096 1.098-.66 1.333-1.27a3.282 3.282 0 0 1 2.374-2.02 3.257 3.257 0 0 1 2.983.891 3.284 3.284 0 0 1 .888 2.995 3.285 3.285 0 0 1-2.012 2.383c-.607.236-1.17.69-1.265 1.337Z"
    />
  </svg>
)
export default Puzzle